import { render, staticRenderFns } from "./company.vue?vue&type=template&id=1050affa&scoped=true&"
import script from "./company.vue?vue&type=script&lang=js&"
export * from "./company.vue?vue&type=script&lang=js&"
import style0 from "./company.vue?vue&type=style&index=0&id=1050affa&prod&lang=css&"
import style1 from "./company.vue?vue&type=style&index=1&id=1050affa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050affa",
  null
  
)

export default component.exports